import React from "react"
import { useNavigate } from "react-router-dom"
import { formatInteger } from "../../../../utils/formatters"
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../../../components/ui/card"
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../../../components/ui/table"
import Button from "../../../../components/ui/Button"
import Icon from "../../../../components/AppIcon"

const FALLBACK_ROWS = [
  { title: "Blockchain Compliance Fundamentals", enrollments: 842, completionRate: 76 },
  { title: "Intro to Data Privacy Law", enrollments: 610, completionRate: 68 },
  { title: "AML Certification Track", enrollments: 495, completionRate: 81 },
  { title: "Workplace Ethics Essentials", enrollments: 388, completionRate: 59 },
  { title: "Cybersecurity for Teams", enrollments: 271, completionRate: 72 },
]

const TopCourses = ({ rows }) => {
  const navigate = useNavigate()
  const data = rows?.length ? rows : FALLBACK_ROWS

  return (
    <Card className="md:col-span-2 p-0 dark:bg-transparent">
      <CardHeader className="pt-5">
        <CardTitle>Top performing courses</CardTitle>
        <CardDescription>Ranked by enrollment</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <Table className="border-t">
          <TableHeader>
            <TableRow>
              <TableHead className="pl-5">Course</TableHead>
              <TableHead className="text-right">Enrollments</TableHead>
              <TableHead className="text-right pr-5">Completion</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map((row) => (
              <TableRow key={row?.title}>
                <TableCell className="pl-5 max-w-[220px] truncate font-medium">{row?.title}</TableCell>
                <TableCell className="text-right text-muted-foreground tabular-nums">{formatInteger(row?.enrollments)}</TableCell>
                <TableCell className="text-right pr-5 tabular-nums text-muted-foreground">{row?.completionRate}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <div className="flex justify-center py-3 border-t border-border">
        <Button variant="ghost" onClick={() => navigate("/organization-dashboard?tab=courses")}>
          View all <Icon name="ArrowRight" size={12} />
        </Button>
      </div>
    </Card>
  )
}

export default TopCourses